var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38123 38.4447H36.6187C39.5062 38.4447 41.3062 35.3135 39.8625 32.8197L25.7437 8.42598C24.3 5.93223 20.7 5.93223 19.2562 8.42598L5.13748 32.8197C3.69373 35.3135 5.49373 38.4447 8.38123 38.4447ZM22.5 25.3197C21.4687 25.3197 20.625 24.476 20.625 23.4447V19.6947C20.625 18.6635 21.4687 17.8197 22.5 17.8197C23.5312 17.8197 24.375 18.6635 24.375 19.6947V23.4447C24.375 24.476 23.5312 25.3197 22.5 25.3197ZM20.625 32.8197H24.375V29.0697H20.625V32.8197Z",
    fill: "#FCBC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFill);
export default __webpack_public_path__ + "static/media/warning-fill.59d8073e.svg";
export { ForwardRef as ReactComponent };